<template>
  <div class="main">
    <div class="main-left">
      <Menu theme="light" style="width: 100%" :accordion="true">
        <MenuItem name="1" v-show="isShow('1')" :to="`/home/main/task/TaskAdd`">
          <Icon type="ios-add-circle-outline"></Icon>
          数据检索
        </MenuItem>
       
         <Submenu name="2" v-show="isShow('2')">
          <template slot="title">
            <Icon type="md-git-branch" />
            任务管理
          </template>
          <MenuItem  name="2-1" :to="`/home/main/task/AllTask`" v-show="isShow('2-1')"
            >任务列表</MenuItem>
          <MenuItem
            name="2-2" :to="`/home/main/task/RecordTask`" v-show="isShow('2-2')"
            >任务记录</MenuItem
          >
        </Submenu>
       <!--<MenuItem name="3" :to="`/home/main/suspected/SuspectedList`"  v-show="isShow('3')">
        <Icon type="ios-bonfire" />
          线索管理</MenuItem > -->
        <Submenu name="3" v-show="isShow('3')">
          <template slot="title">
            <Icon type="ios-bonfire" />
           线索管理
          </template>
          <MenuItem
            name="3-1"
            :to="`/home/main/suspected/SuspectedList`"
            v-show="isShow('3-1')"
            >疑似线索</MenuItem
          >
          <MenuItem
            name="3-2"
            :to="`/home/main/suspected/ConfirmList`"
            v-show="isShow('3-2')"
            >确认线索</MenuItem>
        </Submenu>
        <!--MenuItem
          name="7"
          v-show="isShow('7')"
          :to="`/home/main/yearReport/reportList`"
        >
          <Icon type="md-book" />
          生成报告
        </MenuItem
        <MenuItem name="5" :to="`/home/main/report/ReportList`"  v-show="isShow('3')">
        <Icon type="md-book" />
          生成报告</MenuItem >  -->
      
           <MenuItem
            name="4-1" :to="`/home/main/statistics/taskNumSta`"  v-show="isShow('4-1')" >
             <Icon type="ios-stats" />
             统计分析</MenuItem >
          <!--
              <Submenu name="4" v-show="isShow('4')">
          <template slot="title">
            <Icon type="ios-stats" />
            统计分析
          </template>
            <MenuItem
            name="4-1"
            :to="`/home/main/statistics/taskNumSta`"
            v-show="isShow('4-1')"
            >任务数量统计</MenuItem
          >
          <MenuItem
            name="4-2"
            :to="`/home/main/statistics/queryNumSta`"
            v-show="isShow('4-2')"
            >查询数量统计</MenuItem
          >
          <MenuItem
            name="4-3"
            :to="`/home/main/statistics/caseNumSta`"
            v-show="isShow('4-3')"
            >事件数量统计</MenuItem
          >  </Submenu>-->
          <MenuItem
            name="5-1" :to="`/home/main/report/ReportList`"  v-show="isShow('5-1')" >
            <Icon type="ios-color-filter" />
              巡查统计
             </MenuItem >
              <MenuItem
            name="6-1" :to="`/home/main/createReport/CreateReportList`"  v-show="isShow('5-1')" >
            <Icon type="md-book" />
              生成报告
             </MenuItem >
       <MenuItem  name="7" v-show="isShow('7')" :to="`/home/main/url/urlList`">
            <Icon type="md-paper" />
            链接查询
        </MenuItem>
        <MenuItem name="11" v-show="isShow('11')"  :to="`/home/main/mail/mailList`" >
          <Icon type="ios-paper" />
          通讯录列表
        </MenuItem>
        <MenuItem  name="8" v-show="isShow('8')" :to="`/home/main/company/CompanyList`">
          <Icon type="md-paper" />
          经营单位库
        </MenuItem>
        <MenuItem name="12" v-show="isShow('12')" :to="`/home/main/blacklist/BlackList`">        
          <Icon type="logo-codepen" />
            黑名单库 
        </MenuItem>
        
         <Submenu name="13" v-show="isShow('13')">
          <template slot="title">
            <Icon type="logo-codepen" />
            低价游列表
          </template>
          <MenuItem  name="13-1" :to="`/home/main/minprince/MinPrinceList`" v-show="isShow('13-1')"
            >低价游列表</MenuItem>
          <MenuItem
            name="13-2" :to="`/home/main/minprince/MatchPrinceList`" v-show="isShow('13-2')"
            >未适配的低价游列表</MenuItem
          >
        </Submenu>

        <MenuItem name="9"  v-show="isShow('9')" :to="`/home/main/user/UserList`" >
          <Icon type="ios-contacts" />
          用户管理
        </MenuItem>
        <MenuItem name="10" v-show="isShow('10')" :to="`/home/main/security/IPList`">
          <Icon type="ios-unlock" />
          安全认证
        </MenuItem>
        
      </Menu>
    </div>
    <div class="main-right">
      <router-view :key="$route.path + $route.query.t"></router-view>
    </div>
  </div>
</template>

<script>

export default {
  data: function () {
    return {
      openNames: ["platform:sys"],
      firstLevelMenu: "platform",
      newWin: "",
      theme: "light",
    };
  },
  methods: {
    jump() {
      this.$router.replace({
        path: "/home/main/realtimeData/unservedList",
        query: {
          t: Date.now(),
        },
      });
    },
    installInfoList() {
      this.$router.replace({
        path: "/home/main/realtimeData/installInfoList",
        query: {
          t: Date.now(),
        },
      });
    },
      
  },
  mounted: function () {
    
  },
};
</script>
<style lang='less' scoped>
.main {
  position: fixed;
  top: 100px;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  .main-left {
    width: 17.57%;
    height: 100%;
    float: left;
    overflow: scroll;
  }
  .main-right {
    width: 81%;
    height: 100%;
    float: left;
    overflow: scroll;
    padding: 0 4px;
  }
  a {
    color: #000;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/home/Main.vue